export const floatOrNull = (num) => {
  return (num !== undefined && num === null) || isNaN(num)
    ? null
    : parseFloat(num);
};
